import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Phone, Quote, Award } from 'lucide-react';
export function MeetMike() {
  return <section id="meet-mike" className="bg-white py-20 md:py-28 scroll-mt-24" data-id="element-418">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-419">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-420">
          {/* LEFT — Portrait card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-5" data-id="element-421">
            <div className="relative aspect-[4/5] rounded-3xl bg-gradient-to-br from-brand-800 to-brand-900 overflow-hidden p-10 lg:p-12 flex flex-col justify-between text-white" data-id="element-422">
              {/* Background decorative numbers */}
              <div className="absolute -right-8 -bottom-12 font-display text-[280px] lg:text-[320px] leading-none font-black text-white/[0.06] tracking-tight select-none" data-id="element-423">
                30
              </div>

              <div className="relative flex items-start justify-between" data-id="element-424">
                <div data-id="element-425">
                  <div className="w-20 h-20 rounded-full bg-white text-brand flex items-center justify-center font-display text-3xl font-extrabold" data-id="element-426">
                    MS
                  </div>
                  <div className="mt-5 text-xs uppercase tracking-widest text-white/70 font-semibold" data-id="element-427">
                    Founder · Owner
                  </div>
                </div>
                <span className="inline-flex items-center gap-1.5 px-3 h-7 rounded-full bg-accent text-ink-900 text-[11px] font-bold uppercase tracking-wider" data-id="element-428">
                  <Award size={11} strokeWidth={2.5} data-id="element-429" />
                  Est. 1995
                </span>
              </div>

              <div className="relative" data-id="element-430">
                <div className="font-display text-5xl lg:text-6xl font-extrabold text-white mb-2 leading-none tracking-tight" data-id="element-431">
                  Mike Spear
                </div>
                <div className="text-sm text-white/80 font-medium" data-id="element-432">
                  Master installer · Mitsubishi Diamond Dealer
                </div>

                <div className="mt-7 pt-7 border-t border-white/15 grid grid-cols-2 gap-4" data-id="element-433">
                  <div data-id="element-434">
                    <div className="font-display text-2xl font-extrabold tabular-nums" data-id="element-435">
                      100%
                    </div>
                    <div className="text-[11px] uppercase tracking-wider text-white/60 font-semibold leading-tight mt-0.5" data-id="element-436">
                      Owner-quoted jobs
                    </div>
                  </div>
                  <div data-id="element-437">
                    <div className="font-display text-2xl font-extrabold tabular-nums" data-id="element-438">
                      0%
                    </div>
                    <div className="text-[11px] uppercase tracking-wider text-white/60 font-semibold leading-tight mt-0.5" data-id="element-439">
                      Subcontracted installs
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* RIGHT — Content */}
          <div className="lg:col-span-7 lg:pl-8" data-id="element-440">
            <motion.div initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} data-id="element-441">
              <div className="kicker mb-3" data-id="element-442">Who you are hiring</div>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-ink-900 tracking-tight leading-tight mb-8" data-id="element-443">
                You meet Mike. Not a sales rep.
              </h2>

              <div className="relative pl-6 lg:pl-8 border-l-4 border-accent mb-8" data-id="element-444">
                <Quote size={28} className="absolute -left-4 -top-1 text-accent bg-white px-1" data-id="element-445" />
                <p className="text-lg lg:text-xl leading-relaxed text-ink-900 font-medium max-w-2xl" data-id="element-446">
                  "I started Langler Air in 1995, the same year my eldest was
                  born. Three decades later, I still quote every job personally.
                  If your wife calls about a noise three summers from now, she's
                  calling me."
                </p>
              </div>

              <div className="space-y-4 text-base leading-relaxed text-stone-700 max-w-2xl" data-id="element-447">
                <p data-id="element-448">
                  We size systems properly with on-site load calculations,
                  install with our own team (not subcontractors), and put the
                  price in writing before we start.
                </p>
                <p data-id="element-449">
                  Even if you don't go with us, I'll tell you honestly what size
                  system you actually need. Free advice. No pressure.
                </p>
                <p className="font-semibold text-ink-900" data-id="element-450">
                  If that doesn't sound like what you want, we're not the right
                  installer for you. That's fine. Save my number anyway.
                </p>
              </div>

              <div className="mt-9 flex flex-col sm:flex-row gap-3" data-id="element-451">
                <a href="#quote-form" className="inline-flex items-center justify-center gap-2 h-14 px-7 rounded-xl bg-accent hover:bg-accent-600 text-ink-900 font-bold transition-all hover:scale-[1.02] shadow-cta" data-id="element-452">
                  Get quote from Mike
                  <ArrowRight size={16} strokeWidth={2.5} data-id="element-453" />
                </a>
                <a href="tel:+61864043888" className="inline-flex items-center justify-center gap-2 h-14 px-6 rounded-xl border-2 border-brand text-brand hover:bg-brand-soft font-semibold transition-all" data-id="element-454">
                  <Phone size={15} strokeWidth={2.5} data-id="element-455" />
                  Talk to Mike directly
                </a>
              </div>

              <p className="mt-4 text-xs text-stone-500" data-id="element-456">
                Same business day callback. No spam. No sales tactics.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}